export default __webpack_public_path__ + "static/media/play_store.9e42117b.svg";